module.exports = __webpack_public_path__ + "static/media/star_FFD600.55c51794.svg";